import { Link } from "wouter";
import { FaHome, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaHouse } from "react-icons/fa6";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#212529] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full md:w-1/3 px-4 mb-8 md:mb-0">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-primary mr-2">
                <FaHouse />
              </div>
              <span className="text-xl font-heading font-bold">V&M Group Ltd</span>
            </div>
            <p className="mb-4 text-gray-400">Професионални довършителни работи в София. Качество, с което можете да се гордеете.</p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition duration-300" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition duration-300" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition duration-300" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>
          
          <div className="w-full md:w-1/3 px-4 mb-8 md:mb-0">
            <h3 className="text-lg font-heading font-bold mb-4">Контакти</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="mt-1 mr-2 text-[#FFC857]" />
                <span>ул. "Бузлуджа" 40-42, Петте кьошета, София 1463</span>
              </li>
              <li className="flex items-start">
                <FaPhoneAlt className="mt-1 mr-2 text-[#FFC857]" />
                <span>+359 87 733 8382</span>
              </li>
              <li className="flex items-start">
                <FaEnvelope className="mt-1 mr-2 text-[#FFC857]" />
                <span>vanco.superliski@gmail.com</span>
              </li>
            </ul>
          </div>
          
          <div className="w-full md:w-1/3 px-4">
            <h3 className="text-lg font-heading font-bold mb-4">Бързи връзки</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/" className="text-gray-400 hover:text-white transition duration-300">
                  Начало
                </Link>
              </li>
              <li>
                <Link href="/about" className="text-gray-400 hover:text-white transition duration-300">
                  За нас
                </Link>
              </li>
              <li>
                <Link href="/services" className="text-gray-400 hover:text-white transition duration-300">
                  Услуги
                </Link>
              </li>
              <li>
                <Link href="/projects" className="text-gray-400 hover:text-white transition duration-300">
                  Проекти
                </Link>
              </li>
              <li>
                <Link href="/testimonials" className="text-gray-400 hover:text-white transition duration-300">
                  Отзиви
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-gray-400 hover:text-white transition duration-300">
                  Контакти
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition duration-300">
                  Политика за поверителност
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; {currentYear} V&M Group Ltd. Всички права запазени.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
